// extracted by mini-css-extract-plugin
export var container = "_cl-0";
export var content = "_cl-3";
export var customerTitle = "_cl-4";
export var empty = "_cl-5";
export var gray = "_cl-6";
export var header = "_cl-7";
export var info = "_cl-8";
export var loading = "_cl-2";
export var loadingCard = "_cl-9";
export var oneLine = "_cl-a";
export var personName = "_cl-e";
export var pillContainer = "_cl-b";
export var selected = "_cl-1";
export var text = "_cl-c";
export var twoLines = "_cl-d";
export var unread = "_cl-f";
export var unreadIndicator = "_cl-g";